import { Link } from 'react-router-dom';
import { Breadcrumb, Layout, theme } from 'antd';

import { PageLayout } from '@app/web-components';

export const LandingPage = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  return (
    <>
      <Breadcrumb style={{ margin: '16px 0' }} items={[{ title: <Link to="/">Home</Link> }, { title: 'About' }]} />
      <Layout.Content
        style={{
          padding: 24,
          margin: 0,
          minHeight: 280,
          background: colorBgContainer,
        }}
      >
        <PageLayout.Title title="About" />
        <div style={{ width: '100%' }}>
          <a href="https://wiki.ith.intel.com/display/SAAFWIKI" target="_blank" rel="noreferrer">
            Help Wiki
          </a>
          <br />
          <a
            href="https://circuit.intel.com/content/it/it-support/topic-pages/others/streamlined-access-approval-flow-saaf.html"
            target="_blank"
            rel="noreferrer"
          >
            Report an Issue
          </a>
          <br />
          <a
            href="https://jira.devtools.intel.com/secure/RapidBoard.jspa?rapidView=40395&view=detail&selectedIssue=REQ4EFIP-128"
            target="_blank"
            rel="noreferrer"
          >
            Request a Feature
          </a>
        </div>
        {/* 
        
      
      
        */}
      </Layout.Content>
    </>
  );
};
